import React from "react";
import { TextInput, Button, Label } from "flowbite-react";

const Settings = ({ atrPeriod, setAtrPeriod, profitMultiplier, setProfitMultiplier, stopMultiplier, setStopMultiplier, saveSettings }) => {
  return (
    <div className="p-4 mb-4 rounded-lg dark:bg-slate-800 text-slate-400 bg-white mt-4">
      <h3 className="text-xl font-bold mb-2 text-slate-800 dark:text-slate-200">Stop Loss & Profit Settings</h3>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <Label htmlFor="atrPeriod">ATR Period</Label>
          <TextInput id="atrPeriod" type="number" value={atrPeriod} onChange={(e) => setAtrPeriod(parseInt(e.target.value))} />
        </div>
        <div>
          <Label htmlFor="profitMultiplier">Profit Multiplier</Label>
          <TextInput
            id="profitMultiplier"
            type="number"
            step="0.1"
            value={profitMultiplier}
            onChange={(e) => setProfitMultiplier(parseFloat(e.target.value))}
          />
        </div>
        <div>
          <Label htmlFor="stopMultiplier">Stop Multiplier</Label>
          <TextInput
            id="stopMultiplier"
            type="number"
            step="0.1"
            value={stopMultiplier}
            onChange={(e) => setStopMultiplier(parseFloat(e.target.value))}
          />
        </div>
      </div>
      <Button onClick={saveSettings} className="mt-2">
        Save Settings
      </Button>
    </div>
  );
};

export default Settings;